import ro from 'core/translations/ro'

export default ro
